import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StateService, TransitionService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { BreadcrumbService } from '../../../widgets/breadcrumbs/breadcrumbs.service';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Component({
    selector: 'wiki-header',
    template: require('./wiki.header.component.html')
})
export class WikiHeaderComponent implements OnInit, OnDestroy {
    @Input() project: any = null;
    @Input() projectMenu: any = null;

    pageName: string = '';
    crumbs: any[] = [];
    /** Page loaded by `<wiki-container>` (shared via WikiService) — used for the "updated by" line. */
    wikiPage: any = null;

    private readonly wikiRoot = 'home.project.summary.wiki.page';
    private deregisterSuccess: Function | null = null;
    private pageSub: Subscription | null = null;

    constructor(
        private stateService: StateService,
        private $transitions: TransitionService,
        private breadcrumbService: BreadcrumbService,
        private wikiService: WikiService,
    ) {}

    ngOnInit(): void {
        this.crumbs = this.breadcrumbService.getCrumbs();
        this.breadcrumbService.onCrumbsChange(this.onCrumbsChange);

        this.pageSub = this.wikiService.wikiPage$.subscribe((page: any) => this.wikiPage = page);

        this.refresh(_.get(this.stateService, 'current.name', ''));
        this.deregisterSuccess = this.$transitions.onSuccess({}, (transition) => {
            this.refresh(transition.to().name || '');
        });
    }

    ngOnDestroy(): void {
        this.breadcrumbService.onCrumbsChange(null);
        if (this.deregisterSuccess) { this.deregisterSuccess(); this.deregisterSuccess = null; }
        if (this.pageSub) { this.pageSub.unsubscribe(); this.pageSub = null; }
    }

    /** Mirror breadcrumb changes pushed by the active tab into the heading. */
    onCrumbsChange = (crumbs: any[]): void => { this.crumbs = crumbs || []; };

    /** Refresh the page title and, on the View tab, publish the base breadcrumb trail. */
    private refresh(stateName: string): void {
        const raw = _.get(this.stateService, 'params.pagename', 'FrontPage');
        this.pageName = raw ? decodeURIComponent(raw) : 'FrontPage';

        const isView = (stateName === this.wikiRoot || stateName === this.wikiRoot + '.view');
        if (isView) {
            this.breadcrumbService.setCrumbs([
                this.breadcrumbService.projectCrumb(this.project),
                this.breadcrumbService.translatedCrumb(marker('Wiki'), this.wikiRoot, { pagename: 'FrontPage' }),
                this.breadcrumbService.stateCrumb(this.pageName, this.wikiRoot, { pagename: this.pageName }),
            ]);
        }
    }
}
